module.exports = __webpack_public_path__ + "static/media/profile.cf38a735.png";